export const AUTH_REFRESH_TOKEN_INVALID_CODE = 'AUTH_REFRESH_TOKEN_INVALID';
export const AUTH_REFRESH_UNAVAILABLE_CODE = 'AUTH_REFRESH_UNAVAILABLE';
export const AUTH_SESSION_MISSING_CODE = 'AUTH_SESSION_MISSING';

export type AuthRefreshState = 'active' | 'retryable' | 'terminal';

/**
 * 재로그인이 필요한 인증 오류인지 안정적인 오류 코드로 판정합니다.
 */
export function isTerminalAuthErrorCode(value: unknown): boolean {
  return value === AUTH_REFRESH_TOKEN_INVALID_CODE || value === AUTH_SESSION_MISSING_CODE;
}
